<template>
  <div>
    <Navbar />
    <b-overlay :show="Loading" style="min-height: calc(100vh - 335px)">
      <div class="container" style="margin-top: 100px">
        <b-row>
          <b-col sm="12" lg="6">
            <h2  @click="$router.push({ name: 'Cabinet' })"
                style="cursor: pointer">
              <b-icon-chevron-left
              ></b-icon-chevron-left>
              {{ $t("FormGroup") }}
            </h2>
          </b-col>
          <b-col sm="12" lg="6" class="text-right">
            <div class="d-flex justify-content-end">
              <div class="mr-2">
                <b-button-group
                  @click="Refresh"
                  size="sm"
                  class="sport-group-btn"
                >
                  <b-button
                    @click="filterList.seasonid = 1"
                    :variant="
                      filterList.seasonid == 1 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("firstseason") }}
                  </b-button>
                  <b-button
                    @click="filterList.seasonid = 2"
                    :variant="
                      filterList.seasonid == 2 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("secondseason") }}
                  </b-button>
                </b-button-group>
              </div>
              <div class="mr-2">
                <b-button-group
                  @click="Refresh"
                  size="sm"
                  class="sport-group-btn"
                >
                  <b-button
                    @click="filterList.docyear = 2022"
                    :variant="
                      filterList.docyear == 2022 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("2022") }}
                  </b-button>
                  <b-button
                    @click="filterList.docyear = 2023"
                    :variant="
                      filterList.docyear == 2023 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("2023") }}
                  </b-button>
                  <b-button
                    @click="filterList.docyear = 2024"
                    :variant="
                      filterList.docyear == 2024 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("2024") }}
                  </b-button>
                </b-button-group>
              </div>
              <div class="mr-2">
                <a
                  href="javascript: void(0);"
                  @click="
                $router.push({ name: 'EditFormGroup', params: { id: 0 } })
              "
                  class="btn btn-sm anim-opacity btn-primary"
                >
                  <b-icon-plus></b-icon-plus> {{ $t("Add") }}
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="12">
            <div class="pricing-box1 rounded px-4 pb-2 pt-2 mb-2 ">
              <b-row>
                <b-col sm="12" md="4" class="text-center">
                  <custom-input
                    uppertext
                    v-model="filterList.Search"
                    :placeholder="$t('search')"
                    :label="$t('search')"
                  ></custom-input>
                </b-col>
                <!-- <b-col sm="12" md="2" class="text-center">
                  <custom-select
                    :label="$t('gender')"
                    v-model="filterList.genderid"
                    :options="GenderList"
                  ></custom-select>
                </b-col>
                <b-col sm="12" md="4" class="text-center">
                  <custom-select
                    :label="$t('sporttype')"
                    v-model="filterList.sporttypeid"
                    :options="SportTypeList"
                  ></custom-select>
                </b-col> -->
                <b-col sm="12" md="2">
                  <b-button
                    block
                    variant="outline-primary"
                    size="lg"
                    @click="Refresh"
                  >
                    <p class="m-0 p-0 p-1">
                      <b-spinner v-if="Loading" small></b-spinner>
                      {{ $t("search") }}
                    </p>
                  </b-button>
                </b-col>

                <!-- <b-col sm="12" md="2" class="text-center">
                  {{ $t("mfy") }}
                </b-col>
                <b-col sm="12" md="2" class="text-center">
                  {{ $t("status") }}
                </b-col> -->
                <!-- <b-col>
                        {{ $t("oblast") }} :
                    </b-col> -->
              </b-row>
            </div>
          </b-col>
          <b-col sm="12" md="12">
            <div class="pricing-box rounded px-4 pt-4 pb-2 mb-1 ">
              <b-row>
                <!-- <b-col sm="12" md="2" class="text-center">
                  <b> {{ $t("docnumber") }}</b>
                </b-col> -->
                <b-col sm="12" md="2" class="text-center">
                  <b> {{ $t("docdate") }}</b>
                </b-col>
                <b-col sm="12" md="5" class="text-center">
                  <b> {{ $t("group") }}</b>
                </b-col>
                <!-- <b-col sm="12" md="2" class="text-center">
                  <b> {{ $t("mfy") }}</b>
                </b-col>
                <b-col sm="12" md="2" class="text-center">
                  <b> {{ $t("regionsector") }}</b>
                </b-col> -->
                 <b-col sm="12" md="2" class="text-center">
                  <b> {{ $t("status") }}</b>
                </b-col>
                <b-col sm="12" md="3" class="text-center">
                  <b> {{ $t("actions") }}</b>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <!-- <b-col  sm="12" -->
             <!-- <b-col> -->
          <div class="tableScroll"  v-if="FormGroupList.length != 0">
            <b-col
              sm="12"
              md="12"
              v-for="(item, index) in FormGroupList"
              :key="index"
              v-show="FormGroupList.length > 0"
            >
              <div class="pricing-box rounded px-4 pb-2 pt-2 mb-2 ">
                    <b-row sm="12" md="12">
                      <!-- <b-col sm="12" md="2" style="font-weight:bold">
                        {{ item.docnumber }}
                      </b-col> -->
                      <b-col
                        sm="12"
                        md="2"
                        class="text-center"
                        style="font-weight:bold"
                      >
                        {{ item.docdate }}
                      </b-col>
                      <b-col
                        sm="12"
                        md="5"
                        style="font-weight:bold"
                      >
                        {{ item.detail }}
                      </b-col>
                      <b-col sm="12" md="2" class="text-center">
                        <b-badge
                          style="cursor:pointer"
                          :variant="getColor(item)"
                          class="btn-soft-primary pr-btn"
                          size="sm"
                        >
                          {{ item.statusname }}
                        </b-badge>
                      </b-col>
                      <b-col sm="12" md="3">
                         <a
                          @click="
                            $router.push({
                              name: 'ViewFormGroup',
                              params: { id: item.id },
                            })
                          "
                          class="btn btn-sm btn-soft-primary mr-2 pr-btn"
                        >
                          <b-icon-eye scale="0.8"></b-icon-eye>
                        </a>
                        <a
                          v-if="item.statusid != 2"
                          @click="
                            $router.push({
                              name: 'EditFormGroup',
                              params: { id: item.id },
                            })
                          "
                          class="btn btn-sm btn-soft-primary mr-2  pr-btn"
                        >
                          <b-icon-pencil scale="0.8"></b-icon-pencil>
                        </a>
                        <a
                          v-if="item.statusid != 2"
                          @click="$bvModal.show('DeleteModal' + item.id)"
                          class="btn btn-sm btn-soft-primary mr-2 pr-btn"
                        >
                          <b-icon-trash scale="0.8"></b-icon-trash>
                          <!-- {{ $t("delete") }} -->
                        </a>
                        <a
                          v-if="item.statusid != 2"
                            @click="$bvModal.show('AcceptModal' + item.id)"
                          class="btn btn-sm anim-opacity btn-primary mr-2 pr-btn"
                        >
                          <b-icon-check2-circle
                            scale="0.8"
                          ></b-icon-check2-circle>
                        </a>
                        <a
                          v-if="item.statusid != 1 && item.statusid != 3 && item.statusid != 4"
                          @click="$bvModal.show('CancelModal' + item.id)"
                          class="btn btn-sm btn-soft-primary mr-2  pr-btn"
                        >
                          <b-icon-x-circle scale="0.8"></b-icon-x-circle>
                        </a>
                      </b-col>
                    </b-row>
                <b-modal
                  :id="'DeleteModal' + item.id"
                  :title="$t('delete')"
                  no-close-on-backdrop
                  hide-footer
                >
                  <p>
                    {{ $t("WantDeleteAdm") }}
                  </p>
                  <b-row>
                    <b-col class="text-right">
                      <a
                        @click="$bvModal.hide('DeleteModal' + item.id)"
                        class="btn btn-sm btn-soft-danger mr-2 pr-btn"
                      >
                        {{ $t("no") }}
                      </a>
                      <a
                        @click="Delete(item)"
                        class="btn btn-sm btn-success  pr-btn"
                      >
                        <b-spinner v-if="DeleteLoading" small></b-spinner>
                        {{ $t("yes") }}
                      </a>
                    </b-col>
                  </b-row>
                </b-modal>
                 <b-modal
                :id="'AcceptModal' + item.id"
                :title="$t('Approve')"
                no-close-on-backdrop
                hide-footer
              >
                <b-row class="mt-3">
                  <b-col>
                      <h5>ID : {{ item.id }}</h5>
                    </b-col>
                  <b-col class="text-right">
                    <a
                      @click="$bvModal.hide('AcceptModal' + item.id)"
                      class="btn btn-sm btn-soft-danger mr-2 pr-btn"
                    >
                      {{ $t("no") }}
                    </a>
                    <a
                      @click="Accept(item)"
                      class="btn btn-sm btn-success pr-btn"
                    >
                      <b-spinner v-if="SendLoading" small></b-spinner>
                      {{ $t("yes") }}
                    </a>
                  </b-col>
                </b-row>
              </b-modal>
                <b-modal
                  :id="'CancelModal' + item.id"
                  :title="$t('cancel')"
                  no-close-on-backdrop
                  hide-footer
                >
                  <b-row class="mt-3">
                    <b-col>
                      <h5>ID : {{ item.id }}</h5>
                    </b-col>
                    <b-col class="text-right">
                      <a
                        @click="$bvModal.hide('CancelModal' + item.id)"
                        class="btn btn-sm btn-soft-danger mr-2 pr-btn"
                      >
                        {{ $t("no") }}
                      </a>
                      <a
                        @click="Cancel(item)"
                        class="btn btn-sm btn-success  pr-btn"
                      >
                        <b-spinner v-if="CancelLoading" small></b-spinner>
                        {{ $t("yes") }}
                      </a>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
            </b-col>
          </div>
          <!-- </b-col> -->
        </b-row>
        <b-sidebar
          no-header
          width="400px"
          shadow
          right
          v-model="historySidebar"
          bg-variant="white"
        >
          <div style="width: 100%; height: 100%">
            <div
              class="container-fluid w-100"
              style="
                width: 100% !important;
                position: relative;
                overflow-y: auto;
              "
            >
              <b-row class="w-100">
                <b-col class="text-right close-icon">
                  <!-- <b-img @click="isOpenSidebar = false" src="/images/design/close.svg" /> -->
                  <b-icon-x
                    scale="2.5"
                    style="cursor: pointer; z-index: 9"
                    @click="historySidebar = false"
                  ></b-icon-x>
                </b-col>
              </b-row>
              <b-row class="p-0">
                <b-col>
                  <ul class="timeline">
                    <li v-for="(el, i) in History" :key="i">
                      <b-row class="p-0">
                        <b-col class="float-left">
                          <p class="p-0 m-0 d-flex" style="white-space: nowrap">
                            <b-badge
                              :variant="getColor(el)"
                              style="margin-left: 2px"
                            >
                              {{ el.statusname }}
                            </b-badge>
                          </p>
                          <p class="p-0 m-0">{{ el.dateofcreated }}</p>
                          <p v-if="el.rejectreason" class="p-0 m-0">
                            {{ el.rejectreason }}
                          </p>
                          <p v-if="el.adddata" class="p-0 m-0">
                            {{ el.adddata }}
                          </p>
                          <!-- <p class="p-0 m-0">{{ $t('reason') }} : </p> -->
                        </b-col>
                      </b-row>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-sidebar>
      </div>
    </b-overlay>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";
import {
  BIconPlus,
  BIconPencil,
  BIconTrash,
  BIconXCircle,
  BIconCursor,
  BIconX,
  BIconCheckCircle,
  BIconEye,
  BIconCloudDownload,
  BIconChevronLeft,
  BIconClockHistory,
  BIconCheck2Circle
} from "bootstrap-vue";
import CustomInput from "./components/CustomInput.vue";
import FileManageService from "../services/filemanage.service";
import FormGroupService from "../services/formgroup.service";
import CustomSelect from "./components/CustomSelect.vue";
export default {
  components: {
    Navbar,
    BIconPlus,
    Footer,
    BIconPencil,
    BIconTrash,
    BIconXCircle,
    BIconCursor,
    CustomInput,
    BIconX,
    BIconEye,
    BIconCloudDownload,
    BIconChevronLeft,
    BIconClockHistory,
    BIconCheckCircle,
    BIconCheck2Circle,
    CustomSelect
  },
  data() {
    return {
      lang: localStorage.getItem("locale") || "uz_latn",
      FormGroupList: [],
      DeleteLoading: false,
      filter: {
        smscode: "",
        phonenumber: "",
      },
      SendLoading: false,
      ConfirmSendLoading: false,
      CancelLoading: false,
      Loading: false,
      GenderList : [],
      SportTypeList:[],
      historySidebar: false,
      History: [],
      downloadloading: false,
      AdoptPermisConclusion: {
        docnumber: "",
        docdate: "",
        commenttext: "",
        projectfiletext: "",
      },
      filterList: {
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 400,
        docyear:2024,
        seasonid:2
      },
    };
  },
  created() {
    this.Refresh();
  },
  methods: {
    DownloadFile(item) {
      this.downloadloading = true;
      FileManageService.Get(item.AdoptPermisConclusion.projectfileid)
        .then((res) => {
          this.downloadFile1(res, item.AdoptPermisConclusion);
          this.downloadloading = false;
        })
        .catch((error) => {
          this.makeToast(error.response.data.error, "error");
          this.downloadloading = false;
        });
    },
    OpenAppModal(item) {
      this.$bvModal.show("AppModal" + item.id);
      this.AdoptPermisConclusion = item.AdoptPermisConclusion;
    },
    getColor(item){
          if(item.statusname === 'Создан'){
              return 'primary'
          }
          else if(item.statusname === 'Изменен'){
              return 'info'
          }
          else if(item.statusname === 'Не принято'){
              return 'danger'
          }
          else if(item.statusname === 'Отменено'){
              return 'danger'
          }
          else if(item.statusname === 'Утвержден'){
              return 'success'
          }
          else if(item.statusname === 'Отправлен'){
              return 'warning'
          }
          else{
              return 'primary'
          }
      },
    downloadFile1(response, item) {
      var blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", item.projectfiletext); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    OpenHistory(item) {
      this.History = [];
      this.History = item.history;
      this.historySidebar = true;
    },
    // OpenCancelModal(item) {
    //   this.filter.smscode = "";
    //   this.filter.phonenumber = "";

    //   FormGroupService.CancelApproval(item.id)
    //     .then((res) => {
    //       this.Refresh();
    //     })
    //     .catch((error) => {
    //       this.makeToast(error.response.data.error, "error");
    //     });
    // },
    Cancel(item) {
      this.CancelLoading = true;
      FormGroupService.CancelApproval(item.id)
        .then((res) => {
          this.CancelLoading = false;
          this.$bvModal.hide("CancelModal" + item.id);
          this.Refresh();
        })
        .catch((error) => {
          this.makeToast(error.response.data.error, "error");
          this.CancelLoading = false;
        });
    },
    Refresh() {
      this.Loading = true;
      FormGroupService.GetList(
        this.filterList.Search,
        this.filterList.docyear,
        this.filterList.seasonid,
        this.filterList.SortColumn,
        this.filterList.OrderType,
        this.filterList.PageNumber,
        this.filterList.PageLimit
      )
        .then((res) => {
          this.FormGroupList = res.data.rows;
          this.Loading = false;
        })
        .catch((error) => {
          this.makeToast(error.response.data.error, "error");
          this.Loading = false;
        });
    },
    OpenAcceptModal(item) {
      this.filter.smscode = "";
      this.filter.phonenumber = "";
      this.ConfirmSendLoading = true;
      this.$bvModal.show("AcceptModal" + item.id);
    },
    Accept(item) {
      this.SendLoading = true;
      FormGroupService.Approve(item.id)
        .then((res) => {
          this.SendLoading = false;
          this.$bvModal.hide("AcceptModal" + item.id);
          this.Refresh();
        })
        .catch((error) => {
          this.makeToast(error.response.data.error, "error");
          this.SendLoading = false;
        });
    },
    makeToast(message, type) {
      this.$toast.open({
        message: message,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
    Delete(item) {
      this.DeleteLoading = true;
      FormGroupService.Delete(item.id)
        .then((res) => {
          this.DeleteLoading = false;
          this.makeToast(this.$t("DeleteSuccess"), "success");
          this.$bvModal.hide("DeleteModal" + item.id);
          this.Refresh();
        })
        .catch((error) => {
          this.makeToast(error.response.data.error, "error");
          this.DeleteLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.my-table-padding {
  tr {
    td,
    th {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}
.tableScroll {
  height: 500px;
  overflow-y: scroll;
  width: 100%;
  margin: 0 auto;
}
</style>
